import { inject } from "@angular/core";
import { AuthenticationService } from "../shared/Services/authentication.service";
import { CookieManagerService } from "../shared/Services/cookie.service";

export const isNotLoggedInResolver = () => {
  const auth = inject(AuthenticationService);
  const cookieManager = inject(CookieManagerService);

  if (auth.isLoggedIn()) {
    cookieManager.deleteCookie('token');
    cookieManager.deleteAllCookies();
  }
  return true;
};

